import { css } from '@emotion/react';
import withController from 'components/common/form-controlled/with-controller.hoc';
import BigCheckbox from 'components/common/input-components/big-checkbox';
import withLabel from './with-label.hoc';
import { legacyOnly } from 'constants/themes.constants';
import styled from 'types/theme.types';
import type { CheckboxProps } from 'antd';

const Checkbox = withLabel(
  withController<CheckboxProps>(BigCheckbox, {
    withoutRef: true,
    mapValueTo: 'checked',
    onChangeTransformer: e => e.target.checked
  })
);

/* The 28px row was sized for the legacy 20px box. Against the new design's 16px box and 20px text
   line it pushed the checkbox off its label's centre (UI-polish review, "checkbox not aligned with
   text"). */
export const ControlledBigCheckbox = styled(Checkbox)`
  ${legacyOnly(css`
    @media (min-width: 768px) {
      height: 28px;
    }
  `)}
`;

export default ControlledBigCheckbox;
